import { Injectable, signal, TemplateRef } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TooltipGlobalService {
  visible = signal(false);

  content = signal<TemplateRef<any> | null>(null);

  context = signal<any>(null);

  x = signal(0);
  y = signal(0);

  hoveringTooltip = false;

  private hideTimer: any = null;

  show(template: TemplateRef<any>, context: any, x: number, y: number) {
    this.cancelHide();
    this.content.set(template);
    this.context.set(context);
    this.x.set(x);
    this.y.set(y);
    this.visible.set(true);
  }

  scheduleHide(delay = 300) {
    this.cancelHide();
    this.hideTimer = setTimeout(() => {
      if (!this.hoveringTooltip) {
        this.visible.set(false);
      }
      this.hideTimer = null;
    }, delay);
  }

  cancelHide() {
    if (this.hideTimer) {
      clearTimeout(this.hideTimer);
      this.hideTimer = null;
    }
  }

  tryHide() {
    if (!this.hoveringTooltip) {
      this.visible.set(false);
    }
  }

  forceHide() {
    this.cancelHide();
    this.visible.set(false);
  }
}
